import {TFunction} from 'i18next';
import {ReactNode} from 'react';
import {Translator} from './';

export enum ButtonSet {
  Confirm,
  Cancel,
  CancelAndConfirm,
  TwoConfirm,
  CancelAndTwoConfirm,
}

export interface IPAlertCommon {
  // 같은 groupId가 존재하면 함수만 연결해주고, 나머지 속성은 무시한다
  groupId?: string;
  title?:
    | string
    | ReactNode
    | ReactNode[]
    | ((t: TFunction) => string | ReactNode);
  titleClassName?: string;
  desc?:
    | string
    | ReactNode
    | ReactNode[]
    | ((t: TFunction) => string | ReactNode);
  labelClose?: string | Translator;
  predefinedCallback?: number;
  onRequestClose?: (isDimmedClicked?: boolean) => void;
  callback?: () => void;
  callbackSecond?: () => void;
  isAliveWhenRouting?: boolean;
  isForced?: boolean;
  isTextAlignCenter?: boolean;
  isButtonVertical?: boolean;
  alertZIndex?: number;
  hasAlertMaxHeight?: boolean;
  spaceClassName?: string;
  confirmDisabled?: boolean;
}
export interface IPAlertOneConfirm extends IPAlertCommon {
  buttonSet?: ButtonSet.CancelAndConfirm | ButtonSet.Confirm | ButtonSet.Cancel;
  labelConfirm?: string | Translator;
  labelSecondConfirm?: string | Translator;
}
export interface IPAlertTwoConfirm extends IPAlertCommon {
  buttonSet: ButtonSet.CancelAndTwoConfirm | ButtonSet.TwoConfirm;
  labelConfirm: string | Translator;
  labelSecondConfirm: string | Translator;
}
export type PAlert = IPAlertOneConfirm | IPAlertTwoConfirm;
